export const _msgMimeTypes = ["application/vnd.ms-outlook"];
